import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../Components/Themed"
import { Icons } from '../Components';
import { useColors } from '../constants/useColors';
import type { PlayerFollowerProps, PublicPlayerProps, SmartSearchRequestProps } from '../types';
import { PlayerRecommenderApi } from './api';
import { ActivityIndicator, FlatList, Image } from 'react-native';
import PlayerFollowButton from '../SocialComponents/PlayerFollowButton';
import { SocialComponentApi } from '../SocialComponents/api';

type PlayerRecommenderProps = {
    region?:string,
    location?:any,
    referral_code?:string,
    referrer_id?:string,
    player_id?:string,
    onSelectPlayer:(player:PublicPlayerProps) => void,
    onFullSearch:() => void
}

const PlayerRecommender = ({ location, referrer_id, region, player_id, onSelectPlayer, onFullSearch }:PlayerRecommenderProps) => {
    const Colors = useColors();
    const [ rec_data, setData ] = useState<{
        loading:boolean,
        players:PublicPlayerProps[]
        player_followers:PlayerFollowerProps[],
        offset:number
    }>({
        loading:false,
        offset:0,
        player_followers: [],
        players:[]
    });
    const { loading, players, player_followers } = rec_data;

    useEffect(() => {
        SocialComponentApi.setEnvironment();
        PlayerRecommenderApi.setEnvironment();
        searchPlayers(0, player_id, region, location, referrer_id)
    },[player_id, region, JSON.stringify(location), referrer_id]);


    const searchPlayers = async(page: number, player_id?:string, region?:string, location?:any, referrer_id?:string) => {
        setData({ ...rec_data, loading:true });
        let smart_search:SmartSearchRequestProps = {
            player_id: player_id ?? '0',
            location_detail: location,
            offset: page,
            region: region,
            referrer_id
        }
        const players = await PlayerRecommenderApi.smartSearch(smart_search);
        let pfs:PlayerFollowerProps[] = []
        if(player_id){
            pfs = await PlayerRecommenderApi.getBulkPlayerfollowers(players.map(p => p.player_id));
        }
        setData({
            ...rec_data,
            loading:false,
            player_followers: pfs,
            players,
            offset:page
        })
    }


    const renderPlayers = (data:{ item:PublicPlayerProps, index:number }) => {
        const pf = player_followers.find(pf => pf.following_id == data.item.player_id);
        
        return (
            <Button float style={{ padding:0, margin:4 }} onPress={() => onSelectPlayer(data.item)}>
                <Image
                    source={{ uri: data.item.profile_pic &&  data.item.profile_pic != '' ?  data.item.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:75, width:115, borderTopRightRadius:8, borderTopLeftRadius:8 }}
                    resizeMode='cover'
                />
                <View style={{ flexGrow:1, padding:5}}>
                    <Text theme='h2' textAlign='center' style={{ maxWidth:100 }}>{data.item.username}</Text>
                </View>
                <View transparent style={{ padding:5, borderTopWidth:1, borderColor:Colors.borders.light }}>
                    <PlayerFollowButton
                        player_id={data.item.player_id}
                        following={pf}
                        //follower={pf}
                        onFollowingUpdate={(new_pf) => {
                            setData({ 
                                ...rec_data, 
                                player_followers: player_followers.filter(pf => pf.player_follower_id != new_pf.player_follower_id).concat(new_pf)
                            })
                        }}
                    />
                </View>
            </Button>  
        )
    }

    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:15 }}>
                <Icons.UserIcon color={Colors.text.h1} size={26} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Suggested Players</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Find new players to follow!</Text>
                </View>
                <Button float style={{ padding:10 }} onPress={() => onFullSearch()}>
                    <Icons.SearchIcon size={16} color={Colors.text.action} />
                </Button>
            </View>
            <View style={{ padding:10, flexDirection:'row' }}>
                {loading ?
                <ActivityIndicator
                    style={{ padding:10, alignSelf:'center' }}
                    size={'large'}
                    color={Colors.text.h1}
                />
                :<></>}
                <FlatList
                    key='recommended_players'
                    keyExtractor={(item) => item.player_id.toString()}
                    data={players}
                    horizontal
                    renderItem={renderPlayers}
                />
            </View>
        </View>
        
    )
}

export default PlayerRecommender